import React, { useEffect, useState, useRef } from "react";
import { connect } from "react-redux";
import { Grid, Button, Divider, Typography } from "@material-ui/core";
import { Add, Replay, GetApp } from "@material-ui/icons";

import toJs from "../../../hoc/toJS";
import select from "../../../utils/select";

import ScientificCouncilInsertModal from "../ScientificCouncilInsertModal";
import ScientificCouncilExportModal from "../ScientificCouncilExportModal";

import {
  getAllScientificCouncil,
  getAllScientificCouncilById,
  getFilteredScientificCouncil,
  exportScientificCouncil,
} from "../../../reducer/scientificCouncilNew/action";

function ScientificCouncilButton(props) {
  const { getAllScientificCouncil, getAllScientificCouncilById, getFilteredScientificCouncil } = props;
  const hasInitialized = useRef(false);

  const [inserting, setInserting] = useState(false);
  const [exporting, setExporting] = useState(false);

  let profileId = props.selectedProfileId;
  if (!profileId) profileId = props.profileDetail?.id;

  useEffect(() => {
    if (props.type !== "all" && profileId && !hasInitialized.current) {
      getAllScientificCouncilById(profileId);
      hasInitialized.current = true;
    }
  }, [props.type, profileId, getAllScientificCouncilById]);

  useEffect(() => {
    if (props.type === "all" && props.department !== null && props.department !== undefined) {
      getFilteredScientificCouncil(1, -1, { departmentId: props.department });
    }
  }, [props.type, props.department, getFilteredScientificCouncil]);

  const handleReload = () => {
    if (props.type !== "all") {
      if (profileId) {
        getAllScientificCouncilById(profileId);
        props.handleReload && props.handleReload();
      }
    } else {
      getFilteredScientificCouncil(1, -1, { departmentId: props.department });
      props.handleReload && props.handleReload();
    }
  };
  const handleInsert = () => setInserting(true);

  const handleExport = () => setExporting(true);

  const handleExportData = async (payload) => {
    await props.exportScientificCouncil(payload);
    setExporting(false);
  };

  return (
    <>
      <Grid container>
        <Grid item xs={6}>
          <Typography variant="h5" style={{ lineHeight: "36px" }}>
            Hội đồng khoa học
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <div style={{ float: "right" }}>
            <Button variant="outlined" startIcon={<Replay />} onClick={handleReload}>
              Tải lại
            </Button>
            <Button
              variant="contained"
              color="secondary"
              startIcon={<GetApp />}
              style={{ marginLeft: 8 }}
              onClick={handleExport}
            >
              Xuất Excel
            </Button>
            {props.type !== "all" && (
              <Button
                variant="contained"
                color="primary"
                startIcon={<Add />}
                style={{ marginLeft: 8 }}
                onClick={handleInsert}
              >
                Thêm
              </Button>
            )}
          </div>
        </Grid>
      </Grid>
      <Divider style={{ margin: "8px 0" }} />
      <ScientificCouncilInsertModal inserting={inserting} setInserting={setInserting} setUpdating={props.setUpdating} />
      <ScientificCouncilExportModal
        exporting={exporting}
        setExporting={setExporting}
        handleExportData={handleExportData}
      />
    </>
  );
}

const mapStateToProps = (state) => ({
  isFetching: select(state, "scientificCouncilNewReducer", "isFetching"),
  isFetchingAccepted: select(state, "scientificCouncilNewReducer", "isFetchingAccepted"),
  listFilteredScientificCouncil: select(state, "scientificCouncilNewReducer", "listFiltered"),
  profileDetail: select(state, "profileReducer", "detail"),
});

const mapDispatchToProps = (dispatch) => ({
  getAllScientificCouncil: () => dispatch(getAllScientificCouncil()),
  getAllScientificCouncilById: (id) => dispatch(getAllScientificCouncilById(id)),
  getFilteredScientificCouncil: (page, pageSize, payload) =>
    dispatch(getFilteredScientificCouncil(page, pageSize, payload)),
  exportScientificCouncil: (payload) => dispatch(exportScientificCouncil(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(toJs(ScientificCouncilButton));

